/* eslint-disable react/require-default-props */
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const OrganizationsEmptyComponent = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <p className="text-foreground">{t('titles.youAreNotInAnyOrg')}</p>
    </div>
  );
};
